import { ComboWordGroupGq, ComboWordGroupGqProps } from './ComboWordGroupGq';
import { ComboCombinationGq, ComboCombinationGqProps } from './ComboCombinationGq';
import { GoogleAdsRequestGq, GoogleAdsRequestGqProps } from './GoogleAdsRequestGq';

export interface ComboRequestGq {
  readonly id: number;
  readonly parentProjectId: number;
  readonly googleAdsRequestId: number;
  readonly googleAdsRequest: GoogleAdsRequestGq;
  readonly status: string;
  readonly processingStartTime: string | null;
  readonly wordGroups: ComboWordGroupGq[];
  readonly comboCombinations: ComboCombinationGq[];
}

export const ComboRequestGqProps = `
  id
  parentProjectId
  googleAdsRequestId
  googleAdsRequest { ${GoogleAdsRequestGqProps} }
  status
  processingStartTime
  wordGroups { ${ComboWordGroupGqProps} }
  comboCombinations { ${ComboCombinationGqProps} }
`;
